/**
 * Documents: all authenticated members can list/view/download public documents only (API filters).
 * Team Leader (1) or Secretary (4): full CRUD + private documents. Admins are not elevated.
 */

export function isSecretaryUser(user) {
  return user?.management_id === 4;
}

export function isTeamLeaderUser(user) {
  return Boolean(user?.is_team_leader) || user?.management_id === 1;
}

export function canManageDocuments(user) {
  return isTeamLeaderUser(user) || isSecretaryUser(user);
}

/** Same as managers — only they see private docs */
export function canViewPrivateDocuments(user) {
  return canManageDocuments(user);
}
